import { render, staticRenderFns } from "./ProductTypeDetailsPage.vue?vue&type=template&id=10bce894"
import script from "./ProductTypeDetailsPage.vue?vue&type=script&lang=js"
export * from "./ProductTypeDetailsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports